import { computed, onMounted } from 'vue';

const OTB_WIDGET_CLASS_HIDE = 'otb-widget--hide';

export default function useSalesFloorOTBWidget({ isBrandData, isSpecialtyData }) {
  const showSFOTBWidget = computed(() => !isBrandData.value && !isSpecialtyData.value);

  onMounted(() => {
    if (!showSFOTBWidget.value) {
      document.body.classList.add(OTB_WIDGET_CLASS_HIDE);
    }
  });

  return {
    showSFOTBWidget,
  };
}
